import appStore from 'store';
import api from './utils';

const store = {

    namespaced: true,

    state: {
        hedgeAccountEnum:[],
        exchangeChainEnum:[],
        pickerOptions: {shortcuts: [
            {text: '最近一天', onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24);picker.$emit('pick', [start, end]);}},
            {text: '最近三天', onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*3);picker.$emit('pick', [start, end]);}},
            {text: '最近一周', onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*7);picker.$emit('pick', [start, end]);}},
            {text: '最近一个月', onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*30);picker.$emit('pick', [start, end]);}},
            {text: '最近两个月', onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*60);picker.$emit('pick', [start, end]);}}
        ]},
        binanceDepositWithdrawDesc:[
            {key:'充值状态:0', label:'充值进行中'},
            {key:'充值状态:1', label:'充值已经成功'},
            {key:'提现状态:0', label:'已发送确认Email'},
            {key:'提现状态:1', label:'已被用户取消'},
            {key:'提现状态:2', label:'等待确认'},
            {key:'提现状态:3', label:'被拒绝'},
            {key:'提现状态:4', label:'处理中'},
            {key:'提现状态:5', label:'提现交易失败'},
            {key:'提现状态:6', label:'提现完成'},
        ],
        huobiDepositWithdrawDesc:[
            {key:'unknown', label:'状态未知'},
            {key:'confirming', label:'区块确认中'},
            {key:'confirmed', label:'区块已完成，已经上账，可以划转和交易'},
            {key:'safe', label:'区块已确认，可以提币'},
            {key:'orphan', label:'区块已被孤立'},
            {key:'verifying', label:'待验证'},
            {key:'failed', label:'验证失败'},
            {key:'submitted', label:'已提交'},
            {key:'reexamine', label:'审核中'},
            {key:'canceled', label:'已撤销'},
            {key:'pass', label:'审批通过'},
            {key:'reject', label:'审批拒绝'},
            {key:'pre-transfer', label:'处理中'},
            {key:'wallet-transfer', label:'已汇出'},
            {key:'wallet-reject', label:'钱包拒绝'},
            {key:'confirmed', label:'区块已确认'},
            {key:'confirm-error', label:'区块确认错误'},
            {key:'repealed', label:'已撤销'},
        ],
        huobiTransferDesc:[
            {key:'otc-to-pro', label:'otc到现货'},
            {key:'pro-to-otc', label:'现货到otc'},
            {key:'futures-to-pro', label:'交割合约到现货'},
            {key:'pro-to-futures', label:'现货到交割合约'},
            {key:'dm-swap-to-pro', label:'币本位永续合约到现货'},
            {key:'dm-pro-to-swap', label:'现货到币本位永续合约'},
            {key:'margin-transfer-in', label:'转入到逐仓杠杆'},
            {key:'margin-transfer-out', label:'从逐仓杠杆转出'},
            {key:'pro-to-super-margin', label:'现货到全仓杠杆'},
            {key:'super-margin-to-pro', label:'全仓杠杆到现货'},
            {key:'master-transfer-in', label:'转入到母用户'},
            {key:'master-transfer-out', label:'从母用户转出'},
            {key:'sub-transfer-in', label:'转入到子用户'},
            {key:'sub-transfer-out', label:'从子用户转出'}
        ]
    },

    mutations: {
        setHedgeAccountEnumCache(state, payload) {
            for (let i in payload){
                if ( payload[i].key.startsWith("HUOBI")
                    || payload[i].key.startsWith("BINANCE")
                    || payload[i].key.startsWith("GATE")
                    || payload[i].key.startsWith("MXC")
                    || payload[i].key.startsWith("FTX")
                    || payload[i].key.startsWith("OKEX")
                ){
                    state.hedgeAccountEnum.push(payload[i])
                }
            }
        },

        setExchangeChainEnum(state, payload) {
            state.exchangeChainEnum = payload;
        },
    },

    actions: {
        getHedgeAccountEnum(context) {
            api.queryExchangeAccountEnum().then((response)=>{
                let payload = response.data
                context.commit('setHedgeAccountEnumCache', payload)
            });
        },

        queryExchangeChainEnum(context) {
            api.queryExchangeChainEnum().then((response)=>{
                let payload = response.data
                context.commit('setExchangeChainEnum', payload)
            });
        }
    }
}

appStore.registerModule('balanceReconciliation', store)
